import React from 'react';
import s from './DisplayPrice.scss';
import { PremiumCurrencyFormatter } from '@wix/premium-react-text';
import classNames from 'classnames';
function getParts(priceParts) {
    var indexFirstInt = priceParts.findIndex(function (part) { return part.type === 'integer'; });
    var leftSide = indexFirstInt > 0 ? priceParts.slice(0, indexFirstInt) : [];
    var indexDec = priceParts.findIndex(function (part) { return part.type === 'decimal'; });
    var integerEndIndex = indexDec > -1 ? indexDec : priceParts.length;
    var integer = priceParts.slice(indexFirstInt, integerEndIndex);
    var decimal = indexDec > -1 ? priceParts.slice(indexDec, priceParts.length) : [];
    return {
        leftSide: partsToString(leftSide),
        integer: partsToString(integer),
        decimal: partsToString(decimal),
    };
}
var partsToString = function (priceParts) {
    return priceParts.map(function (part) { return part.value; }).join('');
};
var removeZeroDecimal = function (priceParts) {
    var fraction = priceParts.find(function (part) { return part.type === 'fraction'; });
    if (fraction) {
        var value = parseInt(fraction.value, 10);
        if (value === 0) {
            return priceParts.filter(function (part) { return part.type !== 'fraction' && part.type !== 'literal'; });
        }
    }
    return priceParts;
};
export var DisplayPrice = function (props) {
    var color = props.color, weight = props.weight, cycle = props.cycle, currencyCode = props.currencyCode, hideZeroDecimal = props.hideZeroDecimal, dataHook = props.dataHook, _a = props.theme, theme = _a === void 0 ? '' : _a, fontUpgrade = props.fontUpgrade, _b = props.styling, styling = _b === void 0 ? { currencySymbol: '', price: '', decimalAndCycle: '' } : _b;
    return (React.createElement(PremiumCurrencyFormatter, { currencyCode: currencyCode, render: function (_format, formatToParts) {
            var _a, _b, _c, _d;
            var price = props.price, showDecimalSeparator = props.showDecimalSeparator;
            var priceParts = formatToParts(price);
            if (hideZeroDecimal) {
                priceParts = removeZeroDecimal(priceParts);
            }
            var parts = getParts(priceParts);
            var integer = parts.integer, leftSide = parts.leftSide;
            var decimal = parts.decimal;
            var hasDecimal = priceParts.find(function (part) { return part.type === 'fraction'; });
            var seperator = decimal.charAt(0);
            if (!showDecimalSeparator || !hasDecimal) {
                decimal = decimal.replace(seperator, '');
            }
            return (React.createElement("div", { "data-hook": dataHook, className: classNames(s.priceContainer, s[theme]), style: { color: color } },
                React.createElement("sup", { className: classNames(s.currency, styling.currencySymbol, s[theme], (_a = {}, _a[s.fontUpgrade] = fontUpgrade, _a)), "data-hook": "price-currency" }, leftSide),
                React.createElement("div", { className: classNames(s.priceIntegerPart, s[weight], (_b = {}, _b[s.fontUpgrade] = fontUpgrade, _b), s[theme], styling.price), "data-hook": "price-integer" }, integer),
                React.createElement("div", { "data-hook": "price-decimal-wrapper", className: classNames(s.decimalAndCycleContainer, styling.decimalAndCycle) },
                    React.createElement("sup", { className: classNames(s.priceDecimalPart, (_c = {},
                            _c[s.hidden] = !decimal.length,
                            _c[s.fontUpgrade] = fontUpgrade,
                            _c), s[theme]), "data-hook": "price-decimal" }, decimal ? decimal : null),
                    cycle && (React.createElement("div", { className: classNames(s.cycle, s[theme], (_d = {},
                            _d[s.fontUpgrade] = fontUpgrade,
                            _d)), "data-hook": "cycle" }, "/" + cycle))),
                props.children));
        } }));
};
DisplayPrice.defaultProps = {
    weight: 'normal',
};
DisplayPrice.displayName = 'DisplayPrice';
//# sourceMappingURL=DisplayPrice.js.map